module.exports = __webpack_public_path__ + "static/media/face.febb4f11.svg";